
import { useState, useEffect } from 'react';

interface CapabilitiesCardProps {
  capabilities: string[];
  isVisible: boolean;
}

const CapabilitiesCard = ({ capabilities, isVisible }: CapabilitiesCardProps) => {
  return (
    <div className={`
      relative max-w-sm transition-all duration-1000 transform-gpu
      ${isVisible ? 'translate-y-0 opacity-100 rotate-y-0' : 'translate-y-20 opacity-0 rotate-y-12'}
    `}>
      <div className="
        bg-gradient-to-br from-white/15 to-white/5 
        rounded-xl border border-white/30 p-4
        shadow-2xl backdrop-blur-sm
        hover:shadow-nexx-green/20 hover:shadow-2xl
        hover:scale-[1.02] hover:-rotate-1
        transition-all duration-500 transform-gpu
        relative overflow-hidden
      ">
        {/* Glowing Border Effect */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-nexx-green/20 via-transparent to-nexx-green/20 opacity-0 hover:opacity-100 transition-opacity duration-500" />
        
        <h3 className="text-lg font-bold mb-4 text-center text-white relative z-10">
          Included in Every Package
        </h3>
        
        <div className="grid grid-cols-1 gap-2 relative z-10">
          {capabilities.map((capability, index) => (
            <div 
              key={index} 
              className={`
                flex items-center space-x-3 p-2
                bg-gradient-to-r from-white/10 to-white/5 
                rounded-lg border border-white/20 
                hover:border-nexx-green/50 hover:bg-white/15
                transition-all duration-300 transform-gpu
                hover:scale-105 hover:translate-x-2
                cursor-pointer group
                ${isVisible ? 'animate-fade-in' : 'opacity-0'}
              `}
              style={{ animationDelay: `${index * 0.2 + 1}s` }}
            >
              <div className="relative">
                <div className="w-2 h-2 bg-nexx-green rounded-full animate-pulse" />
                <div className="absolute inset-0 w-2 h-2 bg-nexx-green rounded-full animate-ping opacity-30" />
              </div>
              <div className="text-gray-200 group-hover:text-white transition-colors text-sm font-medium">
                {capability}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CapabilitiesCard;
